import { Checkbox, Form, Input, Select, Upload } from "antd";
import { useHandleImageUpload } from "hooks/useHandleImageUpload";
import ImgCrop from "antd-img-crop";
import React, { useEffect, useState } from "react";
import { Container, Row, Col, Button } from "react-bootstrap";
import { useDispatch, useSelector } from "react-redux";
import { showAlertAction } from "store/alert";
import { positionToOrgMapping2 } from "utils";
import { getOrgStaffProfileOrgField } from "utils";
import { getOrgDashboardIdField } from "utils";
import { positionToOrgMapping } from "utils";
import {
  addNewClient,
  getAllunions,
  getStaffsWithParams,
} from "../store/clients";

const Option = Select.Option;

const RegisterClient = () => {
  const [form] = Form.useForm();
  const dispatch = useDispatch();
  const [cos, setCos] = useState([]);
  const [unions, setUnions] = useState([]);
  const [loading, setLoading] = useState(false);
  const { user } = useSelector((state) => state.users);

  const { handleImageChange, loadingImage, imageUrl } = useHandleImageUpload();

  useEffect(() => {
    setLoading(true);
    const orgType = getOrgStaffProfileOrgField(user?.position);
    const orgIdField = getOrgDashboardIdField(user?.position);
    const orgFieldId = user?.position === "CO" ? user?.id : user?.[orgType]?.id;

    let queryString = "";
    queryString = queryString.concat(`${orgIdField}=${orgFieldId}`);

    if (user?.position === "CO") {
      setCos([user]);
    } else {
      dispatch(getStaffsWithParams(queryString)).then((result) => {
        setCos(result);
      });
    }

    dispatch(getAllunions(queryString)).then((result) => {
      setUnions(result);
    });
    setLoading(false);
  }, []);

  const handleSubmit = async (values) => {
    if (loading) {
      return
    }
    setLoading(true);
    if (!values?.has_payed_fee) {
      showAlertAction({
        message: "You need to verify payment before submit",
        level: "danger",
        isVisible: true,
      });
      return;
    }

    await dispatch(addNewClient({ ...values, image: imageUrl }));
    form.resetFields();
    setLoading(false);
  };

  return (
    <>
      <Container fluid>
        <h3 className="page-title mb-4">Register Client</h3>
        <Form form={form} onFinish={handleSubmit}>
          <Row>
            <Col className="" md="3">
              <Form.Item
                name="title"
                rules={[
                  {
                    required: true,
                    message: "Please provide title",
                  },
                ]}
              >
                <Input
                  placeholder="Title"
                  type="text"
                  className="form-control"
                />
              </Form.Item>
            </Col>
            <Col className="" md="4">
              <Form.Item
                name="surname"
                rules={[
                  {
                    required: true,
                    message: "Please provide surname",
                  },
                ]}
              >
                <Input
                  placeholder="Surname"
                  type="text"
                  className="form-control"
                />
              </Form.Item>
            </Col>
            <Col className="" md="5">
              <Form.Item
                name="firstname"
                rules={[
                  {
                    required: true,
                    message: "Please provide a first name",
                  },
                ]}
              >
                <Input
                  placeholder="First Name"
                  type="text"
                  className="form-control"
                />
              </Form.Item>
            </Col>
          </Row>

          <Row>
            <Col className="" md="6">
              <Form.Item
                name="house_address"
                rules={[
                  {
                    required: true,
                    message: "Please provide house address",
                  },
                ]}
              >
                <Input
                  placeholder="House Adress"
                  type="text"
                  className="form-control"
                />
              </Form.Item>
            </Col>
            <Col className="" md="6">
              <Form.Item
                name="office_address"
                rules={[
                  {
                    required: true,
                    message: "Please provide office address",
                  },
                ]}
              >
                <Input
                  placeholder="Office/Business Address"
                  type="text"
                  className="form-control"
                />
              </Form.Item>
            </Col>
          </Row>

          <Row>
            <Col className="" md="6">
              <Form.Item
                name="phone_number1"
                rules={[
                  {
                    required: true,
                    message: "Please provide phone number 1",
                  },
                ]}
              >
                <Input
                  placeholder="Phone Number 1"
                  type="number"
                  className="form-control"
                />
              </Form.Item>
            </Col>
            <Col className="" md="6">
              <Form.Item name="phone_number2">
                <Input
                  placeholder="Phone Number 2"
                  type="number"
                  className="form-control"
                />
              </Form.Item>
            </Col>
          </Row>

          <Row>
            <Col className="" md="6">
              <Form.Item
                name="marital_status"
                rules={[
                  {
                    required: true,
                    message: "Please provide marital status",
                  },
                ]}
              >
                <Select
                  showSearch
                  placeholder="Select marital Status"
                  optionFilterProp="children"
                  className="custom-input"
                  filterOption={(input, option) =>
                    option.children
                      .toLowerCase()
                      .indexOf(input.toLowerCase()) >= 0
                  }
                  allowClear
                >
                  <Option value="single" key="single">
                    Single
                  </Option>
                  <Option value="married" key="married">
                    Married
                  </Option>
                </Select>
              </Form.Item>
            </Col>
            <Col className="" md="6">
              <Form.Item
                name="number_of_children"
                rules={[
                  {
                    required: true,
                    message: "Please provide number of children",
                  },
                ]}
              >
                <Input
                  placeholder="Number of children"
                  type="number"
                  className="form-control"
                />
              </Form.Item>
            </Col>
          </Row>

          <Row>
            <Col className="" md="4">
              <Form.Item
                name="nin"
                className="mb-3"
                rules={[
                  {
                    required: true,
                    message: "Please provide a valid NIN (11 digits)",
                  },
                  {
                    min: 11,
                    max: 11,
                    message: "Please provide a valid NIN (11 digits)",
                  },
                ]}
              >
                <Input
                  placeholder="Your NIN number"
                  type="number"
                  className="form-control"
                />
              </Form.Item>
            </Col>
            <Col className="" md="4">
              <Form.Item
                name="reg_fee"
                className="mb-3"
                rules={[
                  {
                    required: true,
                    message: "Please provide registration fee",
                  },
                ]}
              >
                <Input
                  placeholder="Registration Fee"
                  type="number"
                  className="form-control"
                />
              </Form.Item>
            </Col>
            <Col className="" md="4">
              <Form.Item
                name="reg_date"
                rules={[
                  {
                    required: true,
                    message: "Please select registration date",
                  },
                ]}
              >
                <Input
                  placeholder="Registration Date"
                  type="date"
                  className="form-control"
                />
              </Form.Item>
            </Col>
          </Row>

          <Row>
            <Col className="" md="4">
              <Form.Item
                name="union_id"
                rules={[
                  {
                    required: true,
                    message: "Please provide a union for this client"
                  },
                ]}
              >
                <Select
                  showSearch
                  placeholder="Select union"
                  optionFilterProp="children"
                  className="custom-input"
                  filterOption={(input, option) =>
                    option.children
                      .toLowerCase()
                      .indexOf(input.toLowerCase()) >= 0
                  }
                  allowClear
                >
                  {unions?.map((inst) => (
                    <Option value={inst.id} key={inst.id}>
                      {inst.name}
                    </Option>
                  ))}
                </Select>
              </Form.Item>
            </Col>

            <Col className="" md="4">
              <Form.Item
                name="co_id"
                rules={[
                  {
                    required: true,
                    message: "Please select a credit officer",
                  },
                ]}
              >
                <Select
                  showSearch
                  placeholder="Select credit officer"
                  optionFilterProp="children"
                  className="custom-input"
                  filterOption={(input, option) =>
                    option.children
                      .toLowerCase()
                      .indexOf(input.toLowerCase()) >= 0
                  }
                  allowClear
                >
                  {cos?.map((inst) => (
                    <Option value={inst.id} key={inst.id}>
                      {inst.name}
                    </Option>
                  ))}
                </Select>
              </Form.Item>
            </Col>

            <Col md="4">
              <Form.Item
                className="d-flex align-items-center checkbox-form-item"
                name="has_payed_fee"
                label="Click to confirm that client has payed registration fee"
                labelAlign="left"
                valuePropName="checked"
                rules={[
                  {
                    required: true,
                    message: "Please confirm payment",
                  },
                ]}
              >
                <Input
                  style={{ width: "initial" }}
                  type="checkbox"
                  className="form-control-checkbox"
                  name="hasPaidRegFee"
                />
              </Form.Item>
            </Col>
          </Row>

          <Row>
            <Col>
              <ImgCrop>
                <Upload
                  name="image"
                  listType="picture-card"
                  className="avatar-uploader p-2"
                  maxCount={1}
                  onChange={handleImageChange}
                >
                  <div className="p-1">
                    <i className="fa fa-upload" aria-hidden="true"></i>
                    Click to Upload
                  </div>
                </Upload>
              </ImgCrop>
            </Col>
          </Row>

          <Row className="mt-3">
            <Col>
              <Button
                variant="primary"
                className="px-5"
                type="submit"
                disabled={loading || loadingImage}
              >
                {loading || loadingImage ? "Loading..." : "Submit"}
              </Button>
            </Col>
          </Row>
        </Form>
      </Container>
    </>
  );
};

export { RegisterClient };
